import { render, staticRenderFns } from "./LiveStreamMod2.vue?vue&type=template&id=5d4383e6"
import script from "./LiveStreamMod2.vue?vue&type=script&lang=js"
export * from "./LiveStreamMod2.vue?vue&type=script&lang=js"
import style0 from "./LiveStreamMod2.vue?vue&type=style&index=0&id=5d4383e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports